import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { useReturnTo } from '../../hooks/useReturnTo/useReturnTo';

type ReturnToLinkProps = Omit<LinkProps, 'to'> & {
  fallbackTo: string;
};

export const ReturnToLink = forwardRef<HTMLAnchorElement, ReturnToLinkProps>(({ fallbackTo, ...props }, ref) => {
  const to = useReturnTo(fallbackTo);

  return <Link ref={ref} to={to} {...props} />;
});
